import JM from "@/assets/js/JMan"
import { jman } from '@/services/jman'

const user = jman.user;
const state = {
	status: { loggedIn: !!user },
	user
};

export default {
	state,
	mutations: {

		sessionRestoreRequested (state) {
			state.status = { restoringSession: true };
			state.user = null;
		},

		sessionRestoreComplete (state) {
			state.status = { loggedIn: !!jman.user };
			state.user = jman.user;
		},

		loginRequested (state) {
			state.status = { loggingIn: true };
			state.user = null;
		},

		loginSuccess (state) {
			state.status = { loggedIn: true };
			state.user = jman.user;
		},

		loginFailure (state) {
			state.status = {};
			state.user = null;
		},

		logout (state) {
			state.status = {};
			state.user = null;
		}

	},

	actions: {

		async restoreSession ({commit, dispatch}) {
			const jwt = await jman.auth.getJwt();
			if (jwt) {
				commit('sessionRestoreRequested');
				dispatch('alert/info', ["Restoring session"], {root: true});
				try {
					await jman.setJWT(jwt);
					commit('sessionRestoreComplete');
					dispatch('alert/success', ["Session restored"], {root: true});
				} catch (err) {
					commit('loginFailure');
					if (err instanceof JM.JManErrorLoginRequired) {
						// Token must have expired, delete it
						// FIXME JMan should take care of this
						await jman.auth.clearJwt();
						commit('alert/error', "Session expired. Please login again.", {root: true});
					} else {
						console.log("loginFailure error", err);
						commit('alert/error', "Failed to restore session", {root: true});
					}
				}
			}
		},

		async login ({commit, dispatch}, credentials) {
			try {
				commit('loginRequested');
				commit('alert/info', "Logging in…", {root: true});
				await jman.login(credentials);
				commit('loginSuccess');
				dispatch('alert/success', ["Logged in"], {root: true});
			} catch (err) {
				if (err instanceof JM.JManErrorLoginFailed) {
					commit('loginFailure');
					commit('alert/error', "Login failed", {root: true});
				}
			}
		},

		async logout ({commit}) {
			await jman.logout();
			commit('logout');
		}

	}
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js